import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { Identifiable, Planzone } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  editProjectListingConfiguration(
    req: Boundaries["editProjectListingConfiguration"]["request"],
  ): void;
}

function useEditProjectListingConfiguration(
  planzone: Identifiable<Planzone>,
): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isEditProjectListingConfigurationRequestPending(planzone),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isEditProjectListingConfigurationRequestSuccess(planzone),
    ),
    isRequestFailure: useSelector(() =>
      selector.isEditProjectListingConfigurationRequestFailure(planzone),
    ),
    editProjectListingConfiguration: core.editProjectListingConfiguration,
  };
}

export { useEditProjectListingConfiguration };
